import { http } from './http-client';

import type {
  ChatMessageDto,
  ChatReadDto,
  ChatRoomKind,
  ChatRoomMessageDto,
  ClubChatRoomDto,
  ConversationDto,
} from './generated';

export type {
  ChatMessageDto,
  ChatReadDto,
  ChatRoomMessageDto,
  ClubChatRoomDto,
  ConversationDto,
};


export const chatApi = {
  listConversations(call?: { signal?: AbortSignal }): Promise<ConversationDto[]> {
    return http.get<ConversationDto[]>('/chat/conversations', { signal: call?.signal });
  },
  listRooms(call?: { signal?: AbortSignal }): Promise<ClubChatRoomDto[]> {
    return http.get<ClubChatRoomDto[]>('/chat/conversations/rooms', { signal: call?.signal });
  },
  roomMessages(kind: ChatRoomKind, subjectId: string, limit = 50, call?: { signal?: AbortSignal }): Promise<ChatRoomMessageDto[]> {
    return http.get<ChatRoomMessageDto[]>(`/chat/conversations/rooms/${kind}/${subjectId}/messages`, {
      query: { limit },
      signal: call?.signal,
    });
  },
  messages(conversationId: string, limit = 50, call?: { signal?: AbortSignal }): Promise<ChatMessageDto[]> {
    return http.get<ChatMessageDto[]>(`/chat/conversations/${conversationId}/messages`, {
      query: { limit },
      signal: call?.signal,
    });
  },
  send(conversationId: string, clientMessageId: string, body: string): Promise<ChatMessageDto> {
    return http.post<ChatMessageDto>(`/chat/conversations/${conversationId}/messages`, {
      clientMessageId,
      body,
    });
  },
  resolveForClient(clientId: string): Promise<ConversationDto> {
    return http.post<ConversationDto>('/chat/conversations/resolve', { clientId });
  },
  markRead(conversationId: string, uptoSeq: number): Promise<void> {
    return http.post<void>(`/chat/conversations/${conversationId}/read`, { uptoSeq });
  },
};

export const chatOversightApi = {
  conversations(
    filter: { trainerId?: string | null; clientId?: string | null; before?: string | null; limit?: number } = {},
    call?: { signal?: AbortSignal },
  ): Promise<ConversationDto[]> {
    return http.get<ConversationDto[]>('/chat/oversight/conversations', {
      query: {
        trainerId: filter.trainerId ?? undefined,
        clientId: filter.clientId ?? undefined,
        before: filter.before ?? undefined,
        limit: filter.limit ?? 50,
      },
      signal: call?.signal,
    });
  },
  messages(conversationId: string, limit = 100, call?: { signal?: AbortSignal }): Promise<ChatMessageDto[]> {
    return http.get<ChatMessageDto[]>(`/chat/oversight/conversations/${conversationId}/messages`, {
      query: { limit },
      signal: call?.signal,
    });
  },
  reads(conversationId: string, call?: { signal?: AbortSignal }): Promise<ChatReadDto[]> {
    return http.get<ChatReadDto[]>(`/chat/oversight/conversations/${conversationId}/reads`, { signal: call?.signal });
  },
};
